import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import { FetchAccountDetailRequest } from "../reducer/types";

export const listAccountRequestLogin = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.QUERY_ACCOUNT_LIST);
  const header = getDataHeaders(massageID, action, true);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const listAccountRequest = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.QUERY_ACCOUNT_LIST);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const accountDetailRequest = async (actionRq: FetchAccountDetailRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.QUERY_ACCOUNT_DETAIL);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    ACCOUNTPROFILE: {
      ACCOUNTNO: actionRq.payload?.ACCOUNTNO,
      ACCOUNTTYPE: actionRq.payload?.ACCOUNTTYPE,
    },
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  return instance.post(url, body);
};

export const limitRemainRequest = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.GET_LIMIT_REMAIN);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  return instance.post(url, body);
};

export const customerPositionRequest = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.GET_CUSTOMER_POSITION);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
